<template>
  <div>
    <el-button @click="openExportWorkflowData" type="primary" size="medium">
      <span class="export-text">
        Export
        <i class="el-icon-upload2"></i>
      </span>
    </el-button>

    <dialog-component
      :title="'Export ' + formbuilderDetails.name + `'s data`"
      :visible="exportTemplatesDataDialogVisible"
      @before-close="CloseExportWorkflowData"
      width="50%"
      :containerWidth="'50%'"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-loading="loading"
      element-loading-text="Downloading Data..."
    >
      <div class="DetailedView-Export">
        <el-input placeholder="Search Field" v-model="filterText"></el-input>
        <el-tree
          class="filter-tree"
          :data="templatesFields"
          :props="defaultProps"
          default-expand-all
          show-checkbox
          highlight-current
          :filter-node-method="filterNode"
          ref="tree"
          node-key="key"
          :default-checked-keys="checkedFields"
        ></el-tree>
      </div>
      <span slot="footer">
        <el-button @click="handleClose">Cancel</el-button>
        <el-button type="success" @click="submitData">
          <i class="fa fa-cloud-upload"></i> Export
        </el-button>
      </span>
    </dialog-component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { groupBy } from "../../helpers/appHelper";
export default {
  props: ["formbuilderDetails", "templatesFields", "selectedFields", "applicationUserFilledDataIds"],
  components: {},
  data() {
    return {
      exportTemplatesDataDialogVisible: false,
      newEntityForm: {},
      sections: [],
      loading: false,
      laodingText: "",
      defaultProps: {
        children: "fields",
        id: "template_id",
        label: "label",
        table_display: "table_display",
      },
      filterText: "",
      checkedFields: [],
    };
  },
  computed: {
    ...mapGetters("formbuilderData", [
      "getUsersFormbuilderTemplatesDataExportStatus",
    ]),
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  mounted() {
    // we have to group the primary fields
    if (this.selectedFields && this.selectedFields.length) {
      this.checkedFields = this.selectedFields;
    }
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    handleClose() {
      this.filterText = "";
      this.exportTemplatesDataDialogVisible = false;
    },
    openExportWorkflowData() {
      this.exportTemplatesDataDialogVisible = true;
      this.templates = groupBy(this.templatesFields, "template_id", true);
    },
    CloseExportWorkflowData() {
      this.exportTemplatesDataDialogVisible = false;
    },
    async submitData() {
      try {
        this.loading = true;

        this.exportTemplatesDataDialogVisible = true;

        let checked = this.$refs.tree.getCheckedNodes();
        checked = checked.filter((e) => !e.fields);

        checked = checked.map((f) => {
          return {
            label: f.label,
            template_name: f.template_title,
            template_id: f.template_id,
            entity_id: f.entity_type_id || null,
            key: f?.key?.split("#").pop(),
            input_type: f.input_type,
            data_table_columns: f.data_table_columns || [],
            validations: f.validations || {},
          };
        });

        let params = {
          formbuilder_id: this.formbuilderDetails._id,
          fields: checked,
          name: this.formbuilderDetails.name,
          timeZoneFormatOffset: this.getTimeZone(),
          data_ids: this.applicationUserFilledDataIds?.length ? this.applicationUserFilledDataIds : [],
        };
        await this.$store.dispatch(
          "formbuilderData/exportUsersFormbuilderTemplatesData",
          params
        );
        if (this.getUsersFormbuilderTemplatesDataExportStatus) {
          this.loading = false;
          this.exportTemplatesDataDialogVisible = false;
        } else {
          this.$notify.error({
            title: "Error",
            message: "Error while downloading data",
          });
          this.loading = false;
          this.exportTemplatesDataDialogVisible = false;
        }
      } catch (err) {
        this.loading = false;
        console.log("submitData", err);
      }
    },
    getTimeZone() {
      let date1 = new Date();
      var sign = date1.getTimezoneOffset() > 0 ? "-" : "+";
      var offset = Math.abs(date1.getTimezoneOffset());
      var hours =
        Math.floor(offset / 60) < 10
          ? "0" + Math.floor(offset / 60)
          : Math.floor(offset / 60);
      var minutes = offset % 60 < 10 ? "0" + (offset % 60) : offset % 60;
      let timezoneoffset = sign + hours + ":" + minutes;
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return timezone + ", UTC" + timezoneoffset;
    },
  },
};
</script>

<style lang="scss" scoped>
.DetailedView-Export {
  margin: 20px;
}
.el-button--primary {
  height: 32px !important;
}
.export-text {
  position: relative;
  bottom: 2px;
}
.el-button--success {
  color: var(--primary-contrast-color);
  background-color: var(--primary-color);
  border: var(--primary-color);
}
</style>
